import React from 'react';
import '../../../../css/common/chat/ChatHeaderControls.css';

type Props = {
  title: string;
  subtitle?: string | null;
};

export default function ChatHeaderTitle({ title, subtitle }: Props) {
  const detail = subtitle?.trim();
  return (
    <div className="chat-header-title">
      <h3 className="chat-header-title__name" title={title}>{title}</h3>
      {detail ? <p className="chat-header-title__subtitle" title={detail}>{detail}</p> : null}
    </div>
  );
}
